export const CATEGORIES = ["Food", "Travel", "Shopping", "Bills", "Health", "Entertainment", "Salary", "Freelance", "Investment", "Other"];

export const CATEGORY_COLORS = {
  Food: "#f97316",
  Travel: "#06b6d4",
  Shopping: "#a855f7",
  Bills: "#ef4444",
  Health: "#22c55e",
  Entertainment: "#eab308",
  Salary: "#3b82f6",
  Freelance: "#8b5cf6",
  Investment: "#10b981",
  Other: "#6b7280",
};

export const generateMockTransactions = () => [
  { id: "1", date: "2024-01-05", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: "2", date: "2024-01-08", description: "Grocery Store", amount: 120.5, category: "Food", type: "expense" },
  { id: "3", date: "2024-01-10", description: "Electric Bill", amount: 95, category: "Bills", type: "expense" },
  { id: "4", date: "2024-01-12", description: "Netflix Subscription", amount: 15.99, category: "Entertainment", type: "expense" },
  { id: "5", date: "2024-01-15", description: "Freelance Project", amount: 1200, category: "Freelance", type: "income" },
  { id: "6", date: "2024-01-18", description: "Restaurant Dinner", amount: 68, category: "Food", type: "expense" },
  { id: "7", date: "2024-01-20", description: "Flight Tickets", amount: 340, category: "Travel", type: "expense" },
  { id: "8", date: "2024-01-22", description: "Online Shopping", amount: 210, category: "Shopping", type: "expense" },
  { id: "9", date: "2024-01-25", description: "Doctor Visit", amount: 75, category: "Health", type: "expense" },
  { id: "10", date: "2024-01-28", description: "Internet Bill", amount: 50, category: "Bills", type: "expense" },
  { id: "11", date: "2024-02-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: "12", date: "2024-02-03", description: "Coffee Shop", amount: 22.5, category: "Food", type: "expense" },
  { id: "13", date: "2024-02-07", description: "Stock Dividend", amount: 320, category: "Investment", type: "income" },
  { id: "14", date: "2024-02-10", description: "Gym Membership", amount: 45, category: "Health", type: "expense" },
  { id: "15", date: "2024-02-12", description: "Uber Ride", amount: 28, category: "Travel", type: "expense" },
  { id: "16", date: "2024-02-14", description: "Valentine Dinner", amount: 135, category: "Food", type: "expense" },
  { id: "17", date: "2024-02-18", description: "Freelance Design", amount: 800, category: "Freelance", type: "income" },
  { id: "18", date: "2024-02-20", description: "Clothing Store", amount: 189, category: "Shopping", type: "expense" },
  { id: "19", date: "2024-02-22", description: "Water Bill", amount: 35, category: "Bills", type: "expense" },
  { id: "20", date: "2024-02-25", description: "Movie Tickets", amount: 32, category: "Entertainment", type: "expense" },
  { id: "21", date: "2024-03-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: "22", date: "2024-03-04", description: "Supermarket", amount: 145, category: "Food", type: "expense" },
  { id: "23", date: "2024-03-08", description: "Phone Bill", amount: 60, category: "Bills", type: "expense" },
  { id: "24", date: "2024-03-10", description: "Hotel Stay", amount: 280, category: "Travel", type: "expense" },
  { id: "25", date: "2024-03-14", description: "Freelance Writing", amount: 950, category: "Freelance", type: "income" },
  { id: "26", date: "2024-03-17", description: "Pharmacy", amount: 55, category: "Health", type: "expense" },
  { id: "27", date: "2024-03-20", description: "Amazon Order", amount: 165, category: "Shopping", type: "expense" },
  { id: "28", date: "2024-03-22", description: "Concert Tickets", amount: 90, category: "Entertainment", type: "expense" },
  { id: "29", date: "2024-03-25", description: "Investment Return", amount: 450, category: "Investment", type: "income" },
  { id: "30", date: "2024-03-28", description: "Food Delivery", amount: 45, category: "Food", type: "expense" },
  { id: "31", date: "2024-04-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: "32", date: "2024-04-03", description: "Rent Payment", amount: 1200, category: "Bills", type: "expense" },
  { id: "33", date: "2024-04-07", description: "Brunch", amount: 55, category: "Food", type: "expense" },
  { id: "34", date: "2024-04-10", description: "Train Pass", amount: 75, category: "Travel", type: "expense" },
  { id: "35", date: "2024-04-13", description: "Freelance App Dev", amount: 1500, category: "Freelance", type: "income" },
  { id: "36", date: "2024-04-16", description: "Fitness Equipment", amount: 120, category: "Health", type: "expense" },
  { id: "37", date: "2024-04-20", description: "Books", amount: 65, category: "Shopping", type: "expense" },
  { id: "38", date: "2024-04-23", description: "Streaming Services", amount: 35, category: "Entertainment", type: "expense" },
  { id: "39", date: "2024-04-26", description: "Bonus", amount: 1000, category: "Salary", type: "income" },
  { id: "40", date: "2024-04-28", description: "Electricity Bill", amount: 88, category: "Bills", type: "expense" },
  { id: "41", date: "2024-05-01", description: "Monthly Salary", amount: 5500, category: "Salary", type: "income" },
  { id: "42", date: "2024-05-04", description: "Cafe Breakfast", amount: 18, category: "Food", type: "expense" },
  { id: "43", date: "2024-05-08", description: "Car Insurance", amount: 200, category: "Bills", type: "expense" },
  { id: "44", date: "2024-05-12", description: "Weekend Trip", amount: 420, category: "Travel", type: "expense" },
  { id: "45", date: "2024-05-15", description: "Freelance SEO", amount: 700, category: "Freelance", type: "income" },
  { id: "46", date: "2024-05-18", description: "Dentist", amount: 180, category: "Health", type: "expense" },
  { id: "47", date: "2024-05-22", description: "Sports Gear", amount: 140, category: "Shopping", type: "expense" },
  { id: "48", date: "2024-05-25", description: "Gaming", amount: 60, category: "Entertainment", type: "expense" },
  { id: "49", date: "2024-05-28", description: "Crypto Return", amount: 280, category: "Investment", type: "income" },
  { id: "50", date: "2024-05-30", description: "Grocery", amount: 110, category: "Food", type: "expense" },
];

export const getMonthlyData = (transactions) => {
  const months = {};
  transactions.forEach((t) => {
    const month = t.date.slice(0, 7);
    if (!months[month]) months[month] = { month, income: 0, expense: 0 };
    if (t.type === "income") months[month].income += t.amount;
    else months[month].expense += t.amount;
  });
  return Object.values(months).sort((a, b) => a.month.localeCompare(b.month)).map((m) => ({
    ...m,
    month: new Date(m.month + "-01").toLocaleString("default", { month: "short", year: "2-digit" }),
    balance: m.income - m.expense,
  }));
};

export const getCategoryData = (transactions) => {
  const cats = {};
  transactions.filter((t) => t.type === "expense").forEach((t) => {
    cats[t.category] = (cats[t.category] || 0) + t.amount;
  });
  return Object.entries(cats).map(([name, value]) => ({ name, value: parseFloat(value.toFixed(2)), color: CATEGORY_COLORS[name] || "#6b7280" })).sort((a, b) => b.value - a.value);
};
